import { render, staticRenderFns } from "./MyGroupBuyCard.vue?vue&type=template&id=2b76867a&scoped=true&"
import script from "./MyGroupBuyCard.vue?vue&type=script&lang=js&"
export * from "./MyGroupBuyCard.vue?vue&type=script&lang=js&"
import style0 from "./MyGroupBuyCard.vue?vue&type=style&index=0&id=2b76867a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b76867a",
  null
  
)

export default component.exports